import { useNavigation } from "react-router";

import * as NavComponents from "~/components/ui/navigation-menu";
import { NavigationMenuLink } from "~/components/ui/navigation-menu";
import { useURL } from "~/contexts";

import explore from "../../images/explore.png";
import shopSale from "../../images/shopSale.png";
import { HorizontalSlider } from "../horizontal-slider";
import Image from "../ui/image";
import { P } from "../ui/text";

export const MainMenu = () => {
  const url = useURL();
  const key = useNavigation().location?.key;
  return (
    <NavComponents.NavigationMenu className="meganav -relative" key={key}>
      <NavComponents.NavigationMenuList>
        <NavComponents.NavigationMenuItem value="shop">
          <NavComponents.NavigationMenuTrigger
            className="text-base font-semibold"
            asChild
          >
            <NavigationMenuLink
              to={url("/shop")}
              isMainMenu
              className="h-[36px] rounded-md px-2 hover:no-underline data-[state=open]:rounded-b-none data-[state=open]:bg-panel-translucent"
            >
              Shop
            </NavigationMenuLink>
          </NavComponents.NavigationMenuTrigger>
          <NavComponents.NavigationMenuContent className="text-base leading-snug tracking-wider text-accent-12">
            <ul className="grid w-screen grid-cols-5 px-6 pt-[24px] 2xl:px-20">
              <li className="row-span-3">
                <P className="font-bold leading-none">New Arrivals</P>
                <NavigationMenuLink
                  to={url("/shop/new-arrivals")}
                  className="block pb-[24px] pt-[28px] font-normal"
                >
                  New Arrivals
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/accessories/bags")}
                  className="block pb-[24px] font-normal"
                >
                  Bags
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[24px]"
                >
                  Tops
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/swimwear")}
                  className="block pb-[28px] font-normal"
                >
                  Swimwear
                </NavigationMenuLink>
                <P className="font-bold leading-none">Best Sellers</P>
                <NavigationMenuLink
                  to={url("/shop/edits/bestsellers")}
                  className="block pt-[28px] font-normal"
                >
                  Best Sellers
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Leggings</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
                <NavigationMenuLink
                  prefetch="intent"
                  to={url(
                    "/shop/bottoms/leggings?refine=c_block-name%3DSuper+Soft",
                  )}
                  className="block pt-[24px] font-normal"
                >
                  Soft leggings
                </NavigationMenuLink>{" "}
                <NavigationMenuLink
                  prefetch="intent"
                  to={url("/shop/bottoms/leggings/2")}
                  className="block pt-[24px] font-normal"
                >
                  Cropped
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings/leggings-with-pockets")}
                  className="block pt-[24px] font-normal"
                >
                  Power UltraSculpt High-Waisted Gym Leggings with pockets
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Bottoms</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Tops</P>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pt-[28px] font-normal"
                >
                  Tops
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[28px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={explore}
                    alt="explore"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[24px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={shopSale}
                    alt="shop-sale"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
              </li>
            </ul>
          </NavComponents.NavigationMenuContent>
        </NavComponents.NavigationMenuItem>

        <NavComponents.NavigationMenuItem>
          <NavComponents.NavigationMenuTrigger
            className="text-base font-semibold"
            asChild
          >
            <NavigationMenuLink
              to={url("/shop/new-arrivals")}
              isMainMenu
              className="h-[36px] rounded-md px-2 hover:no-underline data-[state=open]:rounded-b-none data-[state=open]:bg-panel-translucent"
            >
              New arrivals
            </NavigationMenuLink>
          </NavComponents.NavigationMenuTrigger>

          <NavComponents.NavigationMenuContent className="text-base leading-snug tracking-wider text-accent-12">
            <ul className="grid w-screen grid-cols-5 px-6 pt-[24px] 2xl:px-20">
              <li className="row-span-3">
                <P className="font-bold leading-none">New Arrivals</P>
                <NavigationMenuLink
                  to={url("/shop/new-arrivals")}
                  className="block pb-[24px] pt-[28px] font-normal"
                >
                  New Arrivals
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/accessories/bags")}
                  className="block pb-[24px] font-normal"
                >
                  Bags
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[24px]"
                >
                  Tops
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/swimwear")}
                  className="block pb-[28px] font-normal"
                >
                  Swimwear
                </NavigationMenuLink>
                <P className="font-bold leading-none">Best Sellers</P>
                <NavigationMenuLink
                  to={url("/shop/edits/bestsellers")}
                  className="block pt-[28px] font-normal"
                >
                  Best Sellers
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Leggings</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
                <NavigationMenuLink
                  prefetch="intent"
                  to={url(
                    "/shop/bottoms/leggings?refine=c_block-name%3DSuper+Soft",
                  )}
                  className="block pt-[24px] font-normal"
                >
                  Soft leggings
                </NavigationMenuLink>{" "}
                <NavigationMenuLink
                  prefetch="intent"
                  to={url("/shop/bottoms/leggings/2")}
                  className="block pt-[24px] font-normal"
                >
                  Cropped
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings/leggings-with-pockets")}
                  className="block pt-[24px] font-normal"
                >
                  Power UltraSculpt High-Waisted Gym Leggings with pockets
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Bottoms</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Tops</P>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pt-[28px] font-normal"
                >
                  Tops
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[28px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={explore}
                    alt="explore"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[24px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={shopSale}
                    alt="shop-sale"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
              </li>
            </ul>
          </NavComponents.NavigationMenuContent>
        </NavComponents.NavigationMenuItem>

        <NavComponents.NavigationMenuItem>
          <NavigationMenuLink
            to={url("/shop/accessories")}
            isMainMenu
            className="rounded-md px-4 py-2 text-base font-semibold hover:no-underline"
          >
            Accessories
          </NavigationMenuLink>
        </NavComponents.NavigationMenuItem>

        <NavComponents.NavigationMenuItem>
          <NavigationMenuLink
            to={url("/pages/our-story")}
            isMainMenu
            className="rounded-md px-4 py-2 text-base font-semibold hover:no-underline"
          >
            Story
          </NavigationMenuLink>
        </NavComponents.NavigationMenuItem>
        <NavComponents.NavigationMenuItem>
          <NavigationMenuLink
            to={url("/pages/summer-sale")}
            isMainMenu
            className="rounded-md px-4 py-2 text-base font-semibold hover:no-underline"
          >
            Summer Sale
          </NavigationMenuLink>
        </NavComponents.NavigationMenuItem>
        <NavComponents.NavigationMenuItem>
          <NavigationMenuLink
            to={url("/pages/sales-page")}
            isMainMenu
            className="rounded-md px-4 py-2 text-base font-semibold hover:no-underline"
          >
            Sales Page
          </NavigationMenuLink>
        </NavComponents.NavigationMenuItem>
      </NavComponents.NavigationMenuList>
      <NavComponents.NavigationMenuViewport />
    </NavComponents.NavigationMenu>
  );
};

export const MainMenuMobile = () => {
  const url = useURL();
  return (
    <HorizontalSlider controlsEnabled shouldBeTransparent>
      <NavigationMenuLink
        to={url("/shop")}
        isMainMenu
        className="px-4 py-2 text-base font-semibold hover:underline hover:underline-offset-4"
      >
        Shop
      </NavigationMenuLink>
      <NavigationMenuLink
        to={url("/shop/new-arrivals")}
        isMainMenu
        className="px-4 py-2 text-base font-semibold hover:underline hover:underline-offset-4"
      >
        New arrivals
      </NavigationMenuLink>
      <NavigationMenuLink
        to={url("/shop/accessories")}
        isMainMenu
        className="px-4 py-2 text-base font-semibold hover:underline hover:underline-offset-4"
      >
        Accessories
      </NavigationMenuLink>

      <NavigationMenuLink
        to={url("/pages/our-story")}
        isMainMenu
        className="px-4 py-2 text-base font-semibold hover:underline hover:underline-offset-4"
      >
        Story
      </NavigationMenuLink>
    </HorizontalSlider>
  );
};
